import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setModalState, modalViewsConst } from "../../store/modalSlice";
import { RootState } from "../../store";
import ModalHeader from "./ModalHeader";
import { ReactComponent as InfoCircleIcon } from "../../assets/icons/info-circle.svg";

const ChecklistHintsModal = () => {
  const dispatch = useDispatch();
  const properties = useSelector(
    (state: RootState) => state.modalState.properties
  );
  const { stepNumber, description, hints } = properties ?? {};

  const handleClose = () =>
    dispatch(setModalState({ modalOpen: true, modalView: modalViewsConst.checklist }));

  if (!stepNumber || !description || !hints) return null;

  return (
    <div className="flex flex-col">
      <ModalHeader
        title="How to complete"
        icon={<InfoCircleIcon className="h-5 w-5 text-eai-primary-500" style={{ "--stroke-0": "currentColor" } as any} />}
        onClose={handleClose}
      />
      <div className="flex flex-col p-5 gap-3">
        <p className="text-sm font-semibold text-gray-800 font-Inter">
          Step {stepNumber}: {description}
        </p>
        <ul className="list-disc list-inside space-y-1.5">
          {hints?.map((hint: string, i: number) => (
            <li key={i} className="text-sm text-gray-500 font-Inter">{hint}</li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ChecklistHintsModal;
